import { Dimensions } from "@faire/slate/foundation/dimensions";
import { pxOrRemToUnitlessPx } from "@faire/slate/lib/sizeUnitUtils";

export const POPUP_OFFSET = pxOrRemToUnitlessPx(Dimensions[2]);
export const POPUP_FLIP_DETECTION_OFFSET = pxOrRemToUnitlessPx(Dimensions[2]);
